import React, { createContext, useState } from "react";

export const AppContext = createContext();

const AppContextProvider = (props) => {
  const [data, setData] = useState({
    // 1
    age: "",
    sex: null,
    listeningDevice: "",

    // 2
    volume: 0.5,

    // 3
    isImageTest: false,
  });

  const addSex = (sex) => setData({ ...data, sex });

  const addAge = (age) => setData({ ...data, age });

  const addListeningDevice = (listeningDevice) =>
    setData({ ...data, listeningDevice });

  const addVolume = (volume) => setData({ ...data, volume });

  const addIsImageTest = (isImageTest) => setData({ ...data, isImageTest });

  return (
    <AppContext.Provider
      value={{
        data,
        addSex,
        addAge,
        addListeningDevice,
        addVolume,
        addIsImageTest,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
